// Build A Bundle

import { getImagesByColor } from '../components/images';
import { handleize } from '../helper/functions';
import { is_desktop_size } from '../helper/functions';
import 'unfetch/polyfill';
import 'es6-promise/auto';
import 'slick-carousel';
import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;

// Progress bar button object with states

(async () => {

  // Init bundle button
  console.log('init bundle');
  let bundle_button = document.createElement('DIV');
  bundle_button.classList.add('js-bundle-state-button');
  bundle_button.innerHTML = `
    <div class='js-bundle-message-box bundle-message-box'>
      <p class="js-bundle-message bundle-message hidden"></p>
    </div>
    <div class="fixed z-10 left-0 bottom-0 w-full px-4 lg:px-28 pt-3 pb-8 lg:py-4 text-13px lg:text-18px">
      <button class="js-bundle-get-started bundle-get-started" type="button">Click to Get Started</button>
      <div class="js-bundle-progress-bar bundle-progress-bar hidden">
        <div class="absolute inset-0 bg-white border border-pink-new rounded-full">
          <div class="js-bundle-progress-indicator h-full rounded-full bg-pink-new w-0"></div>
        </div>
        <div class="flex justify-center items-center relative z-10">
          <span class="js-bundle-step-message bundle-step-message">Select A Size</span>
          <span> — </span>
          <span class="js-bundle-step-count">Step 1</span>
        </div>
      </div>
      <button class="js-bundle-review-button bundle-review-button hidden" type="button">Review</button>
    </div>
    `;

  document.body.appendChild(bundle_button);

  let bundle_congrats = document.createElement('DIV');
  bundle_congrats.textContent = 'Your pack is complete!';
  bundle_congrats.classList.add('js-bundle-message-congrats', 'bundle-message-congrats', 'hidden');
  document.querySelector('.js-checkout-container').appendChild(bundle_congrats);

  let step_messages = {
    1: 'Select A Size',
    2: 'Select Design',
    3: 'Select Rise',
    4: 'Add Products'
  };

  // Init bundle object
  window.HPBAB = {};
  const bundle = window.HPBAB;
  bundle.nodes = {};
  bundle.state = {
    step: 0,
    current_total: 0,
    products: [],
    applied_filters: []
  };

  // Sections
  bundle.nodes.intro_steps = document.querySelector('.js-bundle-intro-steps');
  bundle.nodes.mobile_carousel = document.querySelector('.js-bundle-carousel');
  //bundle.nodes.learn_more = document.querySelector('.js-bundle-learn-more');
  bundle.nodes.product_section_container = document.querySelector('.js-bundle-steps-1-2');
  bundle.nodes.product_section = document.querySelector('.js-bundle-product-section');
  bundle.nodes.variant_section = document.querySelector('.js-bundle-variant-section');
  bundle.nodes.filter_section = document.querySelector('.js-bundle-step-3');
  bundle.nodes.collection_section = document.querySelector('.js-bundle-step-4');
  bundle.nodes.categories_section = document.querySelector('.js-bundle-categories-section');

  // Progress
  bundle.nodes.button = document.querySelector('.js-bundle-state-button');
  bundle.nodes.button_get_started = document.querySelector('.js-bundle-get-started');
  bundle.nodes.button_progress = document.querySelector('.js-bundle-progress-bar');
  bundle.nodes.button_progress_message = document.querySelector('.js-bundle-step-message');
  bundle.nodes.button_progress_count = document.querySelector('.js-bundle-step-count');
  bundle.nodes.button_progress_indicator = document.querySelector('.js-bundle-progress-indicator');
  bundle.nodes.button_review_bundle = document.querySelector('.js-bundle-review-button');

  // Messages
  bundle.nodes.message_box = document.querySelector('.js-bundle-message-box');
  bundle.nodes.message = document.querySelector('.js-bundle-message');
  bundle.nodes.message_upgrade_5 = document.querySelector('.js-bundle-upgrade-5');
  bundle.nodes.message_upgrade_7 = document.querySelector('.js-bundle-upgrade-7');

  // Selectors
  bundle.nodes.variants = bundle.nodes.variant_section.querySelector('.js-bundle-variants');
  bundle.nodes.select_products = document.querySelectorAll('.js-bundle-select-product');
  bundle.nodes.select_variants = document.querySelectorAll('.js-bundle-select-variant');

  // Edit Menu
  bundle.nodes.edit_menu = document.querySelector('.js-edit-bundle-section');
  bundle.edit = {};
  bundle.edit.size = document.querySelector('.js-edit-bundle-size');
  bundle.edit.style = document.querySelector('.js-edit-bundle-style');
  bundle.edit.buttons = document.querySelectorAll('.js-bundle-menu-button');

  let bundle_edit_menus = document.querySelectorAll('.js-edit-bundle-trigger');

  for (let trigger of bundle_edit_menus) {
    trigger.addEventListener('click', () => {
      trigger.classList.toggle('open');
    });
  }

  bundle.nodes.message_upgrade_5.addEventListener('click', (e) => {
    let button = bundle.edit.size.querySelector('.js-bundle-menu-button[data-size="7"]');
    editBundle(button);
    bundle.nodes.message_upgrade_5.classList.remove('show');
    bundle.nodes.message_upgrade_5.classList.add('hidden');
    bundle.nodes.button_progress.classList.remove('hidden');
    bundle.nodes.button_review_bundle.classList.add('hidden');
    toggleBundleModal(bundle_review_modal.modal);
  });

  bundle.nodes.message_upgrade_7.addEventListener('click', (e) => {
    let button = bundle.edit.size.querySelector('.js-bundle-menu-button[data-size="12"]');
    editBundle(button);
    bundle.nodes.message_upgrade_7.classList.remove('show');
    bundle.nodes.message_upgrade_7.classList.add('hidden');
    bundle.nodes.button_progress.classList.remove('hidden');
    bundle.nodes.button_review_bundle.classList.add('hidden');
    toggleBundleModal(bundle_review_modal.modal);
  });

  bundle.edit.buttons.forEach((button) => {
    button.addEventListener('click', (e) => {
      editBundle(button);
    });
  });

  const editBundle = function (button) {
    if (bundle.edit.size.contains(button)) {
      if (bundle.state.current_total <= parseInt(button.dataset.size)) {
        // Deselect previous bundle size and hide its variant options in menu
        bundle.edit.size
          .querySelector(`.js-bundle-menu-button[data-product-id="${bundle.state.product_id}"]`)
          .classList.remove('selected');
        bundle.edit.style
          .querySelector(`.js-edit-bundle-variants[data-product-id="${bundle.state.product_id}"]`)
          .classList.add('hidden');
        bundle.edit.style
          .querySelector(`.js-bundle-menu-button[data-variant-id="${bundle.state.variant_id}"]`)
          .classList.remove('selected');

        // Update state with new bundle size
        bundle.state.product_id = button.dataset.productId;
        bundle.state.bundle_size = parseInt(button.dataset.size);
        bundle.state.bundle_discount = parseInt(button.dataset.discount);
        bundle.state.steps_total = bundle.state.bundle_size + 4;
        bundle.nodes.button_progress_count.textContent = `${bundle.state.step} / ${bundle.state.steps_total}`;
        bundle.nodes.button_progress_indicator.style.width = (bundle.state.step / bundle.state.steps_total) * 100 + '%';

        // Select new bundle size in menu and show its variant options
        bundle.edit.size
          .querySelector(`.js-bundle-menu-button[data-product-id="${bundle.state.product_id}"]`)
          .classList.add('selected');
        bundle.edit.style
          .querySelector(`.js-edit-bundle-variants[data-product-id="${bundle.state.product_id}"]`)
          .classList.remove('hidden');
        let selected_size = bundle.nodes.edit_menu.querySelector(
          `.js-bundle-menu-button[data-product-id="${bundle.state.product_id}"]`
        );
        bundle.edit.size.querySelector('.js-bundle-menu-selected').textContent = selected_size.textContent;

        // Find corresponding variant
        let match_variant = bundle.edit.style.querySelector(
          `.js-edit-bundle-variants[data-product-id="${bundle.state.product_id}"] .js-bundle-menu-button[data-variant-title="${bundle.state.variant_title}"]`
        );

        if (match_variant) {
          match_variant.classList.add('selected');
          bundle.state.variant_id = match_variant.dataset.variantId;
          bundle.state.variant_title = match_variant.dataset.variantTitle;
          bundle.edit.style.querySelector('.js-bundle-menu-selected').textContent = match_variant.dataset.variantTitle;
        } else {
          let first_available = bundle.edit.style.querySelector(
            `.js-edit-bundle-variants[data-product-id="${bundle.state.product_id}"] .js-bundle-menu-button`
          );
          first_available.classList.add('selected');
          bundle.state.variant_id = first_available.dataset.variantId;
          bundle.state.variant_title = first_available.dataset.variantTitle;
          bundle.edit.style.querySelector('.js-bundle-menu-selected').textContent =
            first_available.dataset.variantTitle;
          // alert('Sorry, the bundle style you wanted isn\'t avaialble in this size. Please select a new style.');
        }

        if (bundle.state.bundle_size === bundle.state.current_total) {
          bundle.nodes.button_progress.classList.add('hidden');
          bundle.nodes.button_review_bundle.classList.remove('hidden');
          buildBundleReviewProducts(bundle.state.products);
          disableAddToBundle();
          toggleBundleModal(bundle_review_modal.modal);
        } else {
          bundle.nodes.button_progress.classList.remove('hidden');
          bundle.nodes.button_review_bundle.classList.add('hidden');
          enableAddToBundle();
        }
      } else {
        buildBundleReviewProducts(bundle.state.products);
        toggleBundleModal(bundle_review_modal.modal);
        alert('Please remove some items to change bundle size.');
      }
    }

    // Update style
    if (bundle.edit.style.contains(button)) {
      bundle.edit.style
        .querySelector(`.js-bundle-menu-button[data-variant-id="${bundle.state.variant_id}"]`)
        .classList.remove('selected');
      button.classList.add('selected');
      bundle.state.variant_id = button.dataset.variantId;
      bundle.state.variant_title = button.dataset.variantTitle;
      bundle.edit.style.querySelector('.js-bundle-menu-selected').textContent = button.dataset.variantTitle;
    }

    button.closest('.js-edit-bundle-menu').querySelector('.js-edit-bundle-trigger').classList.remove('open');

    console.log('state', bundle.state);
  };

  // Init mobile banner slider
  // if (is_desktop_size === false) {
  //   $(bundle.nodes.mobile_carousel).slick({
  //     dots: false,
  //     arrows: false,
  //     slidesToShow: 1,
  //     adaptiveHeight: true
  //   });

  //   // arrows: true,
  //   // nextArrow: document.querySelector('.js-next'),
  //   // prevArrow: document.querySelector('.js-prev')

  //   // bundle.nodes.learn_more.addEventListener('click', () => {
  //   //   $(bundle.nodes.mobile_carousel).slick('slickNext');
  //   //   document.querySelector('.js-mobile-step-1-img').classList.add('hidden');
  //   // });
  // }

  const startButtonProgres = function () {
    let progress_width = '3.25rem';
    if (is_desktop_size) {
      progress_width = '4.5rem';
    }
    bundle.nodes.button_progress_indicator.style.width = progress_width;
    bundle.nodes.button_get_started.classList.add('hidden');
    bundle.nodes.button_progress.classList.remove('hidden');
  };

  // Bundle start observer
  let bundle_sentinel = document.querySelector('.js-bundle-start-sentinel');
  const bundle_observer = new IntersectionObserver((entries) => {
    // Loop over the entries
    entries.forEach((entry) => {
      // If the element is visible
      if (entry.isIntersecting) {
        bundle_observer.disconnect();
        startButtonProgres();
      }
    });
  });

  bundle_observer.observe(bundle_sentinel);

  bundle.nodes.button_get_started.addEventListener('click', (elem) => {
    let scroll_top =
      bundle.nodes.product_section_container.getBoundingClientRect().top +
      window.scrollY -
      document.querySelector('.js-header').getBoundingClientRect().height;
    window.scroll({ top: scroll_top, left: 0, behavior: 'smooth' });
    startButtonProgres();
  });

  function steps1And2Height() {
    console.log('height check');
    let product_section_height = Math.ceil(bundle.nodes.product_section.getBoundingClientRect().height);
    let variant_section_height = Math.ceil(bundle.nodes.variant_section.getBoundingClientRect().height);
    let product_section_container_height =
      product_section_height > variant_section_height ? product_section_height : variant_section_height;
    bundle.nodes.product_section_container.style.height = product_section_container_height + 'px';
    console.log(
      product_section_height,
      variant_section_height,
      product_section_container_height,
      bundle.nodes.product_section_container
    );
  }
  steps1And2Height();
  window.addEventListener('resize', steps1And2Height);

  // Size Chart
  const open_size_modal = document.querySelectorAll('.js-size-chart-open');
  const close_size_modal = document.querySelector('.js-size-chart-close');
  const overlay_size_modal = document.querySelector('.js-size-chart-overlay');
  const size_modal = document.querySelector('.js-size-chart-modal');
  open_size_modal.forEach((elem) => {
    elem.addEventListener('click', (e) => {
      toggleBundleModal(size_modal);
    });
  });
  close_size_modal.addEventListener('click', (e) => {
    toggleBundleModal(size_modal);
  });
  overlay_size_modal.addEventListener('click', (e) => {
    toggleBundleModal(size_modal);
  });

  // Bundle Exit Modal
  const showExitModal = function (e) {
    e.preventDefault();

    if (Shopify.designMode === undefined) {
      window.removeEventListener('beforeunload', beforeUnloadWarning);
    }

    let href;
    if (e.target.tagName === 'A') {
      href = e.target.getAttribute('href');
    } else {
      href = e.target.closest('a').getAttribute('href');
    }

    exit_modal.continue.addEventListener('click', (e) => {
      if (Shopify.designMode === undefined) {
        window.addEventListener('beforeunload', beforeUnloadWarning);
      }

      exit_modal.modal.addEventListener(
        'transitionend',
        () => {
          exit_modal.modal.classList.add('hidden');
        },
        { once: true }
      );
      document.body.classList.remove('bundle-modal-open');
      window.requestAnimationFrame(() => {
        exit_modal.modal.classList.add('opacity-0');
      });
    });

    exit_modal.exit.addEventListener('click', (e) => {
      window.location.href = href;
    });

    window.requestAnimationFrame(() => {
      document.body.classList.add('bundle-modal-open');
      exit_modal.modal.classList.add('opacity-0');
      exit_modal.modal.classList.remove('hidden');

      window.requestAnimationFrame(() => {
        exit_modal.modal.classList.remove('opacity-0');
      });
    });
  };

  const exit_modal = {
    modal: document.querySelector('.js-exit-modal'),
    continue: document.querySelector('.js-exit-continue-bundle-button'),
    exit: document.querySelector('.js-exit-bundle-button')
  };

  // Turned off for testing
  const beforeUnloadWarning = function (e) {
    e.preventDefault();
    return (e.returnValue = 'Are you sure you want to leave? Your bundle will not be saved.');
  };

  if (Shopify.designMode === undefined) {
    window.addEventListener('beforeunload', beforeUnloadWarning);
  }

  document.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', showExitModal);
  });

  let toggleBundleModal = function (modal) {
    if (modal.classList.contains('hidden')) {
      window.requestAnimationFrame(() => {
        document.body.classList.add('bundle-modal-open');
        modal.classList.add('opacity-0');
        modal.classList.remove('hidden');

        window.requestAnimationFrame(() => {
          modal.classList.remove('opacity-0');
        });
      });
    } else {
      modal.addEventListener(
        'transitionend',
        () => {
          modal.classList.add('hidden');
        },
        { once: true }
      );
      document.body.classList.remove('bundle-modal-open');
      window.requestAnimationFrame(() => {
        modal.classList.add('opacity-0');
      });
    }
  };

  const product_details_modal = {
    modal: document.querySelector('.js-product-details-modal'),
    close: document.querySelector('.js-product-details-modal-close'),
    overlay: document.querySelector('.js-product-details-overlay'),
    image_container: document.querySelector('.js-product-details-image-container'),
    details_container: document.querySelector('.js-product-details-text-container')
  };

  // product_details_modal.focusable = product_details_modal.modal.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
  product_details_modal.close.addEventListener('click', (e) => {
    toggleBundleModal(product_details_modal.modal);
  });

  // Filter
  const dropdown_toggles = document.querySelectorAll('.js-dropdown-toggle');

  if (dropdown_toggles.length > 0) {
    for (const dropdown_toggle of dropdown_toggles) {
      dropdown_toggle.addEventListener('click', () => {
        dropdown_toggle.classList.toggle('open');
        dropdown_toggle.nextElementSibling.classList.toggle('hidden');
      });
    }
  }

  const filter_toggle = document.querySelector('.js-filter-toggle');
  const filter_container = document.querySelector('.js-filter-container');
  const filter_close = document.querySelector('.js-filter-close');

  filter_toggle.addEventListener('click', (e) => {
    toggleBundleModal(filter_container);
  });
  filter_close.addEventListener('click', (e) => {
    toggleBundleModal(filter_container);
  });

  const bundle_filters = document.querySelectorAll('.js-bundle-tag');

  bundle_filters.forEach((elem) => {
    elem.addEventListener('click', (e) => {
      let products = document.querySelectorAll('.quick-shop-product--active');
      let tag = elem.dataset.tag.toLowerCase();

      console.log(tag);

      if (elem.classList.contains('bundle-tag--active')) {
        console.log('remove filter');
        elem.classList.remove('bundle-tag--active');
        bundle.state.applied_filters.splice(bundle.state.applied_filters.indexOf(tag), 1);

        products.forEach((product) => {
          let tags = product
            .querySelector('.js-quick-shop-product-data')
            .dataset.tags.split(',')
            .map((item) => {
              return item.toLowerCase();
            });

          let match_filter = false;
          if (bundle.state.applied_filters.length > 0) {
            match_filter = bundle.state.applied_filters.every((applied_filter) => {
              return tags.includes(applied_filter);
            });
          } else {
            match_filter = true;
          }

          if (match_filter) {
            // console.log('show product');
            // console.log(product);
            product.classList.remove('hidden');
          } else {
            // console.log('hide product');
            // console.log(product);
            product.classList.add('hidden');
          }
        });
      } else {
        console.log('add filter');
        elem.classList.add('bundle-tag--active');

        products.forEach((product) => {
          let tags = product
            .querySelector('.js-quick-shop-product-data')
            .dataset.tags.split(',')
            .map((item) => {
              return item.toLowerCase();
            });

          let match_filter = false;
          if (bundle.state.applied_filters.length > 0) {
            match_filter = bundle.state.applied_filters.every((applied_filter) => {
              return tags.includes(applied_filter);
            });
          } else {
            match_filter = true;
          }

          if (tags.includes(tag) && match_filter) {
            // console.log('show product');
            // console.log(product);
            product.classList.remove('hidden');
          } else {
            // console.log('hide product');
            // console.log(product);
            product.classList.add('hidden');
          }
        });

        bundle.state.applied_filters.push(tag);
      }
    });
  });

  // Sort
  let bundle_sort = document.querySelector('.js-sort');

  bundle_sort.addEventListener('change', (e) => {
    // let products = document.querySelectorAll('.quick-shop-product--active');
    let sort_order = e.target.value;
    let categories = document.querySelectorAll('.js-bundle-product-category');

    for (let i = 0, limit = categories.length; i < limit; i++) {
      let doc_frag = document.createDocumentFragment();
      let products_to_sort = Array.from(categories[i].children);

      switch (sort_order) {
        case 'default':
          console.log('default');
          products_to_sort.sort((a, b) => {
            return parseInt(a.dataset.order) - parseInt(b.dataset.order);
          });
          break;
        case 'price-ascending':
          console.log('price-ascending');
          products_to_sort.sort((a, b) => {
            return parseInt(a.dataset.price) - parseInt(b.dataset.price);
          });
          break;
        case 'price-descending':
          console.log('price-descending');
          products_to_sort.sort((a, b) => {
            return parseInt(b.dataset.price) - parseInt(a.dataset.price);
          });
          break;
        case 'date':
          console.log('date');
          products_to_sort.sort((a, b) => {
            return Date.parse(b.dataset.date) - Date.parse(a.dataset.date);
          });
          break;
        default:
          console.log('error');
      }

      for (let j = 0, limit = products_to_sort.length; j < limit; j++) {
        doc_frag.appendChild(products_to_sort[j]);
      }

      categories[i].append(doc_frag);
    }
  });

  // Select bundle product
  bundle.nodes.select_products.forEach((elem) => {
    elem.addEventListener('click', (e) => {
      // Update state
      bundle.state.product_id = elem.dataset.productId;
      bundle.state.bundle_size = parseInt(elem.dataset.size);
      bundle.state.bundle_discount = parseInt(elem.dataset.discount);
      bundle.state.variant_id = '';
      bundle.state.variant_title = '';
      bundle.state.step = 2;
      bundle.state.steps_total = bundle.state.bundle_size + 4;
      bundle.nodes.button_progress_message.textContent = step_messages[bundle.state.step];
      bundle.nodes.button_progress_count.textContent = `${bundle.state.step} / ${bundle.state.steps_total}`;

      // Edit menu update
      bundle.edit.size.querySelectorAll('.js-bundle-menu-button').forEach((elem) => {
        elem.classList.remove('selected');
      });
      bundle.edit.style.querySelectorAll('.js-edit-bundle-variants').forEach((elem) => {
        elem.classList.add('hidden');
      });
      let selected_size = bundle.nodes.edit_menu.querySelector(
        `.js-bundle-menu-button[data-product-id="${bundle.state.product_id}"]`
      );
      bundle.edit.style
        .querySelector(`.js-edit-bundle-variants[data-product-id="${bundle.state.product_id}"]`)
        .classList.remove('hidden');
      bundle.edit.size.querySelector('.js-bundle-menu-selected').textContent = selected_size.textContent;
      selected_size.classList.add('selected');

      window.requestAnimationFrame(() => {
        steps1And2Height();
        bundle.nodes.variant_section.classList.remove('bundle-variant-section--hidden');
        bundle.nodes.product_section.classList.add('bundle-product-section--exit');
      });

      bundle.nodes.select_products.forEach((elem) => {
        elem.classList.remove('bg-beige');
      });
      elem.classList.add('bg-beige');

      // Update Indicator bar
      // let progress_increment = 'calc(' + (100 / (bundle.state.steps_total - 1)) * bundle.state.step + ')';
      // bundle.nodes.button_progress_indicator.style.setProperty('width', progress_increment);
      bundle.nodes.button_progress_indicator.style.width = (bundle.state.step / bundle.state.steps_total) * 100 + '%';

      // Update Elements
      // bundle.nodes.button_get_started.classList.add('hidden');
      // bundle.nodes.button_progress.classList.remove('hidden');

      // Add variants
      bundle.nodes.variants.innerHTML = elem
        .closest('.js-bundle-product')
        .querySelector('.js-bundle-variants').innerHTML;
      // Add event listeners to variant selectors
      bundle.nodes.variants.querySelectorAll('.js-bundle-select-variant').forEach((elem) => {
        elem.addEventListener('click', (e) => {
          initVariantSelectors(elem);
        });
      });
      // Show variants
      bundle.nodes.variant_section.classList.remove('hidden');

      // let scroll_top = bundle.nodes.variant_section.getBoundingClientRect().top + window.scrollY - document.querySelector('.js-header').getBoundingClientRect().height;
      // window.scroll({ top: scroll_top, left: 0, behavior: 'smooth' });

      console.log('bundle product state', bundle.state);
    });
  });

  // Select Bundle Variant
  let initVariantSelectors = function (elem) {
    // Update state
    bundle.state.variant_id = elem.dataset.variantId;
    bundle.state.variant_title = elem.dataset.variantTitle;
    bundle.state.step = 3;
    bundle.nodes.button_progress_message.textContent = step_messages[bundle.state.step];
    bundle.nodes.button_progress_count.textContent = `${bundle.state.step} / ${bundle.state.steps_total}`;
    bundle.nodes.button_progress_indicator.style.width = (bundle.state.step / bundle.state.steps_total) * 100 + '%';

    // Edit menu update
    let selected_style = bundle.nodes.edit_menu.querySelector(
      `.js-bundle-menu-button[data-variant-id="${bundle.state.variant_id}"]`
    );
    bundle.edit.style.querySelector('.js-bundle-menu-selected').textContent = selected_style.textContent;
    selected_style.classList.add('selected');
    bundle.nodes.edit_menu.classList.remove('hidden');

    // Hide steps 1 and 2
    // bundle.nodes.product_section_container.classList.add('hidden');

    window.requestAnimationFrame(() => {
      // Show Steps 3 and 4
      bundle.nodes.product_section_container.classList.add('bundle-steps-1-2--pre-exit');
      bundle.nodes.filter_section.classList.remove('hidden');
      bundle.nodes.collection_section.classList.remove('hidden');

      window.requestAnimationFrame(() => {
        bundle.nodes.product_section_container.addEventListener(
          'transitionend',
          (e) => {
            // Hide steps 1 and 2
            bundle.nodes.product_section_container.classList.add('hidden');
          },
          { once: true }
        );

        // let scroll_top = bundle.nodes.filter_section.getBoundingClientRect().top + window.scrollY - document.querySelector('.js-header').getBoundingClientRect().height;
        let scroll_top =
          bundle.nodes.edit_menu.getBoundingClientRect().top +
          window.scrollY -
          document.querySelector('.js-header').getBoundingClientRect().height;
        // window.scroll({ top: scroll_top, left: 0, behavior: 'smooth' });
        window.scroll({ top: scroll_top, left: 0, behavior: 'auto' });

        window.requestAnimationFrame(() => {
          bundle.nodes.product_section_container.classList.add('bundle-steps-1-2--exit');

          window.requestAnimationFrame(() => {
            bundle.nodes.filter_section.classList.remove('bundle-step-3--hidden');
            bundle.nodes.collection_section.classList.remove('bundle-step-4--hidden');
          });
        });
      });
    });

    // Hide mobile slider and intro steps
    if (is_desktop_size) {
      bundle.nodes.intro_steps.classList.add('hidden');
    } else {
      bundle.nodes.mobile_carousel.classList.add('hidden');
    }

    console.log('bundle variant state', bundle.state);
  };

  // Bundle Warning Modal
  const warning_modal = {
    modal: document.querySelector('.js-warning-modal'),
    continue: document.querySelector('.js-warning-continue-bundle-button'),
    empty: document.querySelector('.js-warning-empty-bundle-button')
  };

  warning_modal.continue.addEventListener('click', (e) => {
    toggleBundleModal(warning_modal.modal);
  });

  // Bundle Filter Selectors
  bundle.nodes.filter_selectors = document.querySelectorAll('.js-bundle-filter-style');
  bundle.nodes.filter_selectors.forEach((elem) => {
    elem.addEventListener('click', () => {
      if (bundle.state.products.length > 0 && bundle.state.filter !== elem.dataset.filter) {
        // window.alert("You can only add one type of rise to your bundle.");

        warning_modal.empty.addEventListener('click', (e) => {
          console.log('new_filter', elem.dataset.filter);

          // Empty bundle and remove filters
          bundle.state.applied_filters.length = 0;
          let active_filters = document.querySelectorAll('.bundle-tag--active');
          active_filters.forEach((elem) => {
            elem.classList.remove('bundle-tag--active');
          });

          // Remove products
          let bundle_products = bundle.state.products;
          bundle.state.filter = elem.dataset.filter;

          bundle.nodes.filter_selectors.forEach((elem) => {
            elem.classList.remove('bg-beige');
          });
          elem.classList.add('bg-beige');

          let selected_filter = elem.dataset.filter;
          let products = document.querySelectorAll('.js-quick-shop-product-data');

          // Hide and Show Products based on category selected
          for (let product of products) {
            if (product.dataset.tags.includes(selected_filter)) {
              product.closest('.js-quick-shop-product').classList.remove('hidden');
              product.closest('.js-quick-shop-product').classList.add('quick-shop-product--active');
            } else {
              product.closest('.js-quick-shop-product').classList.add('hidden');
              product.closest('.js-quick-shop-product').classList.remove('quick-shop-product--active');
            }
          }

          for (let i = 0, limit = bundle_products.length; i < limit; i++) {
            updateProductCounter(
              0,
              document
                .querySelector(`.js-quick-shop-product [data-id="${bundle_products[i].product.id}"]`)
                .closest('.js-quick-shop-product')
            );
          }

          // Update state
          bundle.state.products.length = 0;
          bundle.state.current_total = 0;
          bundle.state.step = 4;

          bundle.nodes.button_review_bundle.classList.add('hidden');
          bundle.nodes.button_progress.classList.remove('hidden');
          bundle.nodes.button_progress_count.textContent = `${bundle.state.step} / ${bundle.state.steps_total}`;
          bundle.nodes.button_progress_indicator.style.width =
            (bundle.state.step / bundle.state.steps_total) * 100 + '%';

          toggleBundleModal(warning_modal.modal);

          console.log('bundle filter state', bundle.state);
        });

        toggleBundleModal(warning_modal.modal);
      } else {
        bundle.state.filter = elem.dataset.filter;

        bundle.nodes.filter_selectors.forEach((elem) => {
          elem.classList.remove('bg-beige');
        });
        elem.classList.add('bg-beige');

        let selected_filter = elem.dataset.filter;
        let products = document.querySelectorAll('.js-quick-shop-product-data');

        // Update state
        bundle.state.step = 4;
        bundle.nodes.button_progress_message.textContent = step_messages[bundle.state.step];
        bundle.nodes.button_progress_count.textContent = `${bundle.state.step} / ${bundle.state.steps_total}`;
        bundle.nodes.button_progress_indicator.style.width = (bundle.state.step / bundle.state.steps_total) * 100 + '%';

        // Empty bundle and remove filters
        bundle.state.applied_filters.length = 0;
        let active_filters = document.querySelectorAll('.bundle-tag--active');
        active_filters.forEach((elem) => {
          elem.classList.remove('bundle-tag--active');
        });

        // Hide and Show Products based on category selected
        for (let product of products) {
          if (product.dataset.tags.includes(selected_filter)) {
            product.closest('.js-quick-shop-product').classList.remove('hidden');
            product.closest('.js-quick-shop-product').classList.add('quick-shop-product--active');
          } else {
            product.closest('.js-quick-shop-product').classList.add('hidden');
            product.closest('.js-quick-shop-product').classList.remove('quick-shop-product--active');
          }
        }

        // Show Products
        bundle.nodes.categories_section.classList.remove('hidden');

        let scroll_top =
          bundle.nodes.collection_section.getBoundingClientRect().top +
          window.scrollY -
          document.querySelector('.js-header').getBoundingClientRect().height;
        window.scroll({ top: scroll_top, left: 0, behavior: 'smooth' });
      }

      console.log('bundle filter state', bundle.state);
    });
  });

  // Add Bundle To Cart
  var addBundleToCart = function (products) {
    document.querySelectorAll('a').forEach((link) => {
      link.removeEventListener('click', showExitModal);
    });

    if (Shopify.designMode === undefined) {
      window.removeEventListener('beforeunload', beforeUnloadWarning);
    }

    bundle.nodes.edit_menu.classList.add('invisible');

    var items = [];

    let bundle_id = `${bundle.state.variant_id}-${Math.round(Math.random() * 1000000)}`;

    // Add products
    for (let i = 0, limit = bundle.state.products.length; i < limit; i++) {
      let item = {
        id: products[i].variant.id,
        quantity: products[i].quantity,
        properties: {
          _bundle: bundle_id
        }
      };
      items.push(item);
    }

    // Add bundle last
    let item = {
      id: parseInt(bundle.state.variant_id),
      quantity: 1,
      properties: {
        _bundle: bundle_id,
        _parent: true
      }
    };
    items.push(item);

    const cart = document.querySelector('cart-drawer');

    var headers = new Headers({ 'Content-Type': 'application/json' });
    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        items,
        sections: cart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      })
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', request)
      .then((response) => response.json())
      .then((response) => {
        if (response) {
          cart.trigger(cart);
          cart.renderContents(response);
          console.log('Congratulations!');
          bundle.nodes.message.classList.add('hidden');
          bundle.nodes.message.classList.remove('show');
          let congrats_message = document.querySelector('.js-bundle-message-congrats');
          congrats_message.classList.remove('hidden');
          congrats_message.addEventListener('animationend', (e) => {
            congrats_message.classList.remove('show');
            congrats_message.classList.add('hidden');
          });
          congrats_message.classList.add('show');
        } else {
          alert('Sorry, something went wrong. Please try reloading the page, and rebuilding your bundle.');

          throw new Error('Something went wrong');
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        if (error.status == 422) {
          alert('Out of stock.');
        }
      });
  };

  // Bundle Quick Shop
  function getOneVariantOfEachColor(product, option_index) {
    const result = [];
    const map = new Map();

    for (const item of product.variants) {
      if (!map.has(item[option_index])) {
        map.set(item[option_index], true);
        result.push(item);
      }
    }

    return result;
  }

  function setSelectors(prod, el) {
    let images = el.querySelectorAll('[data-image]');

    for (let image of images) {
      image.onload = function () {
        el.querySelector('.js-loader').style.display = 'none';
      };
    }

    let radios = prod ? el.querySelectorAll(`[data-type="radio-color"][data-product_id="${prod.id}"]`) : [];

    for (let radio of radios) {
      if (!radio.classList.contains('has-listener')) {
        radio.classList.add('has-listener');
      }

      radio.addEventListener('change', async () => {
        let variant_id = parseInt(radio.dataset.variantId);

        // change the prices

        let variants = prod.variants;
        let selected = variants.find((e) => e.id === variant_id);

        el.querySelector('.js-variant-price-' + prod.id).innerHTML = '$' + selected.price / 100;

        if (el.querySelector('.js-variant-compare-at-price-' + prod.id)) {
          if (selected.compare_at_price) {
            el.querySelector('.js-variant-compare-at-price-' + prod.id).innerHTML =
              '$' + selected.compare_at_price / 100;
          } else {
            el.querySelector('.js-variant-compare-at-price-' + prod.id).innerHTML = '';
          }
        }

        // change the images
        let images_obj = getImagesByColor(prod);

        let images = images_obj[radio.dataset.color];

        if (images) {
          // let srcset = buildSrcset(images);

          el.querySelector('.js-loader').style.display = 'block';

          let imgFileType = '.jpg';

          if (images[0].includes('.png')) {
            imgFileType = '.png';
          }

          if (images[0]) {
            let prodImg1 = images[0].replace('https:', ''),
              src1Desktop = prodImg1.replace(imgFileType, `_x1600${imgFileType}`),
              src1Mobile = prodImg1.replace(imgFileType, `_x900${imgFileType}`);

            el.querySelector(`[data-image="1"][data-product_id="${prod.id}"]`).src = images[0];
            el.querySelector(`[data-image="1"][data-src_desktop="${prod.id}"]`).setAttribute('srcset', src1Desktop);
            el.querySelector(`[data-image="1"][data-src_mobile="${prod.id}"]`).setAttribute('srcset', src1Mobile);
          }

          if (images[1]) {
            let prodImg2 = images[1].replace('https:', ''),
              src2Desktop = prodImg2.replace(imgFileType, `_x1600${imgFileType}`),
              src2Mobile = prodImg2.replace(imgFileType, `_x900${imgFileType}`);

            el.querySelector(`[data-image="2"][data-product_id="${prod.id}"]`).src = images[1];
            el.querySelector(`[data-image="2"][data-src_desktop="${prod.id}"]`).setAttribute('srcset', src2Desktop);
            el.querySelector(`[data-image="2"][data-src_mobile="${prod.id}"]`).setAttribute('srcset', src2Mobile);
            el.querySelector(`[data-image="2"][data-product_id="${prod.id}"]`).style.display = '';
          } else {
            el.querySelector(`[data-image="2"][data-product_id="${prod.id}"]`).style.display = 'none';
          }
        }
      });
    }
  }

  const bundle_review_modal = {
    modal: document.querySelector('.js-review-bundle-modal'),
    close: document.querySelector('.js-review-bundle-modal-close'),
    overlay: document.querySelector('.js-review-bundle-overlay'),
    counter: document.querySelector('.js-bundle-review-count'),
    total: document.querySelector('.js-bundle-review-total'),
    price: document.querySelector('.js-review-bundle-total-price'),
    product_container: document.querySelector('.js-bundle-products-container'),
    add_to_bag: document.querySelector('.js-review-bundle-add-to-cart'),
    continue: document.querySelector('.js-review-continue-bundle-button')
  };

  bundle_review_modal.close.addEventListener('click', (e) => {
    toggleBundleModal(bundle_review_modal.modal);
  });

  bundle_review_modal.continue.addEventListener('click', (e) => {
    toggleBundleModal(bundle_review_modal.modal);
  });

  bundle_review_modal.add_to_bag.addEventListener('click', () => {
    addBundleToCart(bundle.state.products);
    bundle.nodes.button.classList.add('hidden');
    toggleBundleModal(bundle_review_modal.modal);
  });

  const buildBundleReviewProducts = function (products) {
    bundle_review_modal.product_container.innerHTML = '';

    let product_frag = document.createDocumentFragment();

    for (let i = 0, limit = products.length; i < limit; i++) {
      let product = products[i].product;
      let variant = products[i].variant;
      let color_option = '';
      let option_2 = '';
      let option_3 = '';
      if (variant.option1) {
        color_option = `
          <div class="flex items-center flex-nowrap gap-3 p-0.5 pb-1 overflow-x-auto">
            <div class='bundle-color-item'>
              <div class='text-0px' for='option-${variant.id}' data-option='${handleize(variant.option1)}'>${variant.option1}</div>
            </div>
          </div>
        `;
      }
      if (variant.option2) {
        option_2 = `
          <div class="flex items-center flex-nowrap gap-3 p-0.5 overflow-x-auto">
            <span class="bundle-size-item">
              <div for="${product.id}-${variant.option2}">${variant.option2}</div>
            </span>
          </div>
        `;
      }
      if (variant.option3) {
        option_3 = `
          <div class="flex items-center flex-nowrap gap-3 p-0.5 overflow-x-auto">
            <span class="bundle-type-item">
              <div for="${product.id}-${variant.option3}">${variant.option3}</div>
            </span>
          </div>
        `;
      }

      let compare_at_price = variant.compare_at_price / 100;
      let price = variant.price / 100;
      let compare_at_price_html =
        isNaN(compare_at_price) || compare_at_price == 0
          ? ''
          : '<span class="mr-1 line-through text-gray js-variant-compare-at-price-' +
            product.id +
            '">$' +
            compare_at_price +
            '</span>';
      let price_html = price ? '<span class="js-variant-price-' + product.id + '">$' + price + '</span>' : '';

      let imgFileType = '.jpg',
        image = variant.featured_image.src;

      if (image.includes('.png')) {
        imgFileType = '.png';
      }

      let prodImg = image.replace('https:', '');

      let srcDesktop = prodImg.replace(imgFileType, `_x1600${imgFileType}`),
        srcMobile = prodImg.replace(imgFileType, `_x900${imgFileType}`);

      var img = `
          <picture>
              <source data-image="1" data-src_mobile="${product.id}" srcset="${srcMobile}" media="(max-width: 767px)">
              <source data-image="1" data-src_desktop="${product.id}" srcset="${srcDesktop}" media="(min-width: 768px)">
              <img loading="lazy"
                      src="${prodImg}"
                      class="w-full h-full object-cover inset-0 absolute"
                      data-image="1"
                      data-product_id="${product.id}"
                      alt="">
          </picture>
      `;

      let item = `<div class="block relative pt-135 w-full h-0 mb-4 border border-beige">
                    ${img}
                  </div>
                  <div class="text-13px font-bold">${product.title}</div>
                  <div class="py-1">${compare_at_price_html}${price_html}</div>
                  <div class="text-13px">
                    ${color_option}
                    ${option_2}
                    ${option_3}
                  </div>
                  <button class="js-review-bundle-remove text-gray text-13px lg:text-14px p-0.5 font-bold underline" data-product-id="${product.id}" data-variant-id="${variant.id}" type="button">
                    Remove
                  </button>
      `;

      for (let j = 0, limit = products[i].quantity; j < limit; j++) {
        let product_elem = document.createElement('div');
        product_elem.classList.add('js-review-bundle-modal-product', 'review-bundle-modal__product');
        product_elem.innerHTML = item;
        product_frag.append(product_elem);
      }
    }

    bundle_review_modal.product_container.append(product_frag);

    let bundle_remove_buttons = document.querySelectorAll('.js-review-bundle-remove');
    console.log(bundle_remove_buttons);

    bundle_remove_buttons.forEach((remove_button) => {
      console.log(remove_button);
      remove_button.addEventListener('click', (e) => {
        removeBundleItem(remove_button);
      });
    });

    bundle_review_modal.counter.textContent = bundle.state.current_total;
    bundle_review_modal.total.textContent = bundle.state.bundle_size;

    bundle_review_modal.add_to_bag.classList.remove('hidden');
    bundle_review_modal.continue.classList.add('hidden');

    let bundle_price = 0;
    let regular_price = 0;
    let bundle_discount = 0;

    if (bundle.state.current_total == 5) {
      bundle_discount = 0.1;
    } else if (bundle.state.current_total >= 7 && bundle.state.current_total < 12) {
      bundle_discount = 0.15;
    } else if (bundle.state.current_total >= 12 && bundle.state.current_total < 24) {
      bundle_discount = 0.2;
    } else {
      bundle_discount = 0;
    }

    console.log(bundle_discount);

    for (let i = 0, limit = bundle.state.products.length; i < limit; i++) {
      let product = bundle.state.products[i];
      regular_price += product.variant.price * product.quantity;
      bundle_price += product.variant.price * product.quantity * (1 - bundle_discount);
    }

    bundle_price = parseFloat(bundle_price.toFixed(2));
    console.log(bundle_price, regular_price);
    console.log(bundle_price === regular_price);

    let price =
      bundle_price !== regular_price
        ? '<span class="line-through"> $' +
          (regular_price / 100).toFixed(2) +
          '</span>' +
          '&nbsp; $' +
          (bundle_price / 100).toFixed(2)
        : '<span> $' + (regular_price / 100).toFixed(2) + '</span>';

    bundle_review_modal.price.innerHTML = price;

    toggleBundleModal(bundle_review_modal.modal);
  };

  // Update product card counter
  function updateProductCounter(quantity, product) {
    let counter = product.querySelector('.js-bundle-product-counter');
    let current_total = parseInt(counter.textContent);

    if (quantity === 0) {
      counter.classList.add('hidden');
      counter.textContent = quantity;
    } else {
      if (current_total + quantity > 0) {
        counter.classList.remove('hidden');
      } else {
        counter.classList.add('hidden');
      }
      counter.textContent = current_total + quantity;
    }
  }

  const removeBundleItem = function (remove_button) {
    let product_id = remove_button.dataset.productId;
    let variant_id = parseInt(remove_button.dataset.variantId);
    let bundle_products = bundle.state.products;

    for (let i = 0, limit = bundle_products.length; i < limit; i++) {
      if (variant_id === bundle_products[i].variant.id) {
        bundle_products[i].quantity--;
        if (bundle_products[i].quantity === 0) {
          bundle_products.splice(i, 1);
        }
        break;
      }
    }

    bundle.state.current_total--;
    bundle.state.step--;

    remove_button.closest('.js-review-bundle-modal-product').remove();
    bundle_review_modal.counter.textContent = bundle.state.current_total;
    bundle_review_modal.add_to_bag.classList.add('hidden');
    bundle_review_modal.continue.classList.remove('hidden');

    bundle.nodes.button_review_bundle.classList.add('hidden');
    bundle.nodes.button_progress_count.textContent = `${bundle.state.step} / ${bundle.state.steps_total}`;
    bundle.nodes.button_progress.classList.remove('hidden');

    updateProductCounter(
      -1,
      document.querySelector(`.js-quick-shop-product [data-id="${product_id}"]`).closest('.js-quick-shop-product')
    );
    enableAddToBundle();
  };

  const disableAddToBundle = function () {
    document.querySelectorAll('button.js-bundle-add-button').forEach((elem) => {
      elem.classList.add('invisible');
    });
  };

  const enableAddToBundle = function () {
    document.querySelectorAll('.js-bundle-add-button').forEach((elem) => {
      elem.classList.remove('invisible');
    });
  };

  bundle.nodes.button_review_bundle.addEventListener('click', () => {
    console.log('review');
    buildBundleReviewProducts(bundle.state.products);
    disableAddToBundle();
  });

  const quick_shop_products = document.querySelectorAll('.js-quick-shop-product-data');

  for (const qs_product of quick_shop_products) {
    if (qs_product.dataset.handle) {
      let product = await fetch(`/products/${qs_product.dataset.handle}.js`)
        .then((response) => response.json())
        .then((data) => {
          return data;
        });

      let images;

      // get the option for color
      let color_option = product.options.find((e) => e.name.toLowerCase() === 'color');
      // create a colors selector element
      let colors_selector = '';

      // if color is an option, create swatches
      if (color_option) {
        let images_obj = getImagesByColor(product);

        // get the option index for color
        let color_index = 'option' + color_option.position;
        let variants_to_check;

        // get the variants, one of each color
        variants_to_check = getOneVariantOfEachColor(product, color_index);

        let index = 0;
        for (let variant of variants_to_check) {
          if (images === undefined) {
            images = images_obj[variant[color_index]];
          }

          let checked = index == 0 ? 'checked' : '';

          let color_swatch = `
              <div class="color-item bundle-color-item">
                  <input type="radio" name="${product.id}-color" data-type="radio-color" data-color="${variant[color_index]}" value="${variant[color_index]}" data-variant-id="${variant.id}" data-product_id="${product.id}" id="option-${variant.id}" ${checked} />
                  <label class="text-0px" for="option-${variant.id}" data-option="${handleize(variant[color_index])}">${variant[color_index]}</label>
              </div>`;

          colors_selector = colors_selector + color_swatch;
          index++;
        }
      } else {
        images = product.images;
      }

      let size_options = product.options.find((e) => e.name.toLowerCase() === 'size');
      let size_options_el = '';

      if (size_options) {
        let checked = 'checked';

        size_options_el = `<div class="flex items-center flex-nowrap gap-3 p-0.5 pb-2 overflow-x-auto" role="radiogroup" aria-labelledby="radiogroup-size-${product.id}">
                            <p id="radiogroup-size-${product.id}" class="screen-reader-only">Size options for ${product.title}</p>`;

        for (const size_option of size_options.values) {
          size_options_el += `
            <span class="bundle-size-item">
              <input type="radio" id="${product.id}-${size_option}" name="${product.id}-size" value="${size_option}" class='hidden' ${checked}>
              <label for="${product.id}-${size_option}">${size_option}</label>
            </span>
          `;
          checked = '';
        }
        size_options_el += '</div>';
      }

      let type_options = product.options.find((e) => e.name.toLowerCase() === 'type');
      let type_options_el = '';

      if (type_options) {
        let build_type_options = false;

        for (let i = 0, limit = type_options.values.length; i < limit; i++) {
          if (type_options.values[i].toLowerCase() === 'flat') {
            build_type_options = true;
          }
        }

        if (build_type_options) {
          let checked = 'checked';

          type_options_el = `<div class="hidden items-center flex-nowrap gap-3 p-0.5 overflow-x-auto" role="radiogroup" aria-labelledby="radiogroup-type-${product.id}">
                          <p id="radiogroup-type-${product.id}" class="screen-reader-only">Type options for ${product.title}</p>`;

          for (const type_option of type_options.values) {
            if (type_option.toLowerCase() !== 'rolled') {
              type_options_el += `
                <span class="bundle-type-item">
                  <input type="radio" id="${product.id}-${type_option}" name="${product.id}-type" value="${type_option}" class='hidden' ${checked}>
                  <label for="${product.id}-${type_option}">${type_option}</label>
                </span>
              `;
              checked = '';
            }
          }
          type_options_el += '</div>';
        }
      }

      let compare_at_price = product.variants[0].compare_at_price / 100;
      let price = product.variants[0].price / 100;

      let compare_at_price_html =
        isNaN(compare_at_price) || compare_at_price == 0
          ? ''
          : '<span class="mr-1 line-through text-gray js-variant-compare-at-price-' +
            product.id +
            '">$' +
            compare_at_price +
            '</span>';
      let price_html = price ? '<span class="js-variant-price-' + product.id + '">$' + price + '</span>' : '';

      // HOTFIX for undefined images NEED TO REFACTOR
      if (images === undefined) {
        images = product.images;
      }
      let imgFileType = '.jpg',
        images1 = images[0],
        images2 = images[1];

      var img1 = '',
        img2 = '';

      if (images1) {
        if (images1.includes('.png')) {
          imgFileType = '.png';
        }

        let prodImg1 = images1.replace('https:', '');

        let src1Desktop = prodImg1.replace(imgFileType, `_x1600${imgFileType}`),
          src1Mobile = prodImg1.replace(imgFileType, `_x900${imgFileType}`);

        img1 = `
              <picture>
                  <source data-image="1" data-src_mobile="${product.id}" srcset="${src1Mobile}" media="(max-width: 767px)">
                  <source data-image="1" data-src_desktop="${product.id}" srcset="${src1Desktop}" media="(min-width: 768px)">
                  <img loading="lazy"
                          src="${prodImg1}"
                          class="w-full h-full object-cover inset-0 absolute"
                          data-image="1"
                          data-product_id="${product.id}"
                          alt="">
              </picture>
          `;
      } else {
        img1 = `
          <picture>
              <source data-image="1" data-src_mobile="${product.id}" srcset="" media="(max-width: 767px)">
              <source data-image="1" data-src_desktop="${product.id}" srcset="" media="(min-width: 768px)">
              <img loading="lazy"
                      src=""
                      class="w-full h-full object-cover inset-0 absolute"
                      data-image="1"
                      data-product_id="${product.id}"
                      alt=""
                      style="display:none;">
          </picture>
      `;
      }

      if (images2) {
        if (images2.includes('.png')) {
          imgFileType = '.png';
        } else {
          imgFileType = '.jpg';
        }

        let prodImg2 = images2.replace('https:', '');

        let src2Desktop = prodImg2.replace(imgFileType, `_x1600${imgFileType}`),
          src2Mobile = prodImg2.replace(imgFileType, `_x900${imgFileType}`);

        img2 = `
              <picture>
                  <source data-image="2" data-src_mobile="${product.id}" srcset="${src2Mobile}" media="(max-width: 767px)">
                  <source data-image="2" data-src_desktop="${product.id}" srcset="${src2Desktop}" media="(min-width: 768px)">
                  <img loading="lazy"
                      src="${images2}"
                      class="w-full h-full object-cover inset-0 absolute opacity-0 hover:opacity-100 transition duration-300"
                      data-image="2"
                      data-product_id="${product.id}"
                      alt="">
              </picture>
          `;
      } else {
        img2 = `
              <picture>
                  <source data-image="2" data-src_mobile="${product.id}" srcset="" media="(max-width: 767px)">
                  <source data-image="2" data-src_desktop="${product.id}" srcset="" media="(min-width: 768px)">
                  <img loading="lazy"
                      src=""
                      class="w-full h-full object-cover inset-0 absolute opacity-0 hover:opacity-100 transition duration-300"
                      data-image="2"
                      data-product_id="${product.id}"
                      alt=""
                      style="display:none;">
              </picture>
          `;
      }

      const url = qs_product.dataset.url ? qs_product.dataset.url : `/products/${product.handle}`;

      let item = `<div>
                    <div class="js-bundle-add-button cursor-pointer block relative pt-135 w-full h-0 mb-4 border border-beige">
                      ${img1}
                      ${img2}
                      <div class='js-loader absolute z-10 bg-white bg-opacity-20 w-full h-full inset-0'><div class="lds-roller absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>
                    </div>

                    <p class="text-13px lg:text-15px font-bold">${product.title}</p>

                    <div class="flex justify-between lg:justify-start items-center lg:gap-8 py-2">
                      <div>
                        ${compare_at_price_html}${price_html}
                      </div>
                      <button class="js-view-bundle-product-details text-gray text-13px lg:text-14px underline" data-product-details="${product.id}" type="button">View Details</button>
                    </div>

                    <div>
                      <div class="flex items-center flex-nowrap gap-3 p-0.5 pb-2 overflow-x-auto" role="radiogroup" aria-labelledby="radiogroup-color-${product.id}">
                        <p id="radiogroup-color-${product.id}" class="screen-reader-only">Color swatches for ${product.title}</p>
                        ${colors_selector}
                      </div>
                      ${type_options_el}
                      ${size_options_el}
                    </div>
                    <button class="js-bundle-add-button text-pink-new text-13px lg:text-14px p-0.5 font-bold underline mt-2">
                      Add To Box
                    </button>
                  </div>`;

      // add the products to the DOM before adding the event listeners
      // el.insertAdjacentHTML('beforeend', item)

      qs_product.innerHTML = item;
      qs_product.classList.add('built');

      // qs_product.querySelectorAll('a').forEach((link) => {
      //   link.addEventListener('click', showExitModal);
      // });

      // set the selectors
      setSelectors(product, qs_product);

      let view_details_button = qs_product.querySelector('.js-view-bundle-product-details');
      view_details_button.addEventListener('click', (e) => {
        let product_details_markup = view_details_button
          .closest('.js-quick-shop-product')
          .querySelector('.js-bundle-product-details').innerHTML;
        product_details_modal.details_container.innerHTML = product_details_markup;

        let triggers = product_details_modal.details_container.querySelectorAll('.js-trigger');

        for (let trigger of triggers) {
          trigger.addEventListener('click', () => {
            trigger.classList.toggle('open');
          });
        }

        toggleBundleModal(product_details_modal.modal);
      });

      // Add to cart functionality
      qs_product.querySelectorAll('.js-bundle-add-button').forEach((button) => {
        button.addEventListener('click', () => {
          let radios = qs_product.querySelectorAll('input[type=radio]');
          let selected = [];

          // set the selected variant
          for (var j = 0; j < radios.length; j++) {
            if (radios[j].checked) {
              selected.push(radios[j].value);
            }
          }

          let variant_title = selected.join(' / ');
          const variant = product.variants.find((e) => e.title == variant_title);

          console.log('product', product);
          console.log('variant', variant);
          console.log('variant_title', variant_title);

          if (variant.available) {
            // Add bundle products
            let add_new_product = true;

            // Check if product already included and increase quantity
            for (let i = 0, limit = bundle.state.products.length; i < limit; i++) {
              if (bundle.state.products[i].variant.id === variant.id) {
                bundle.state.products[i].quantity += 1;
                add_new_product = false;
                bundle.state.current_total++;
                updateProductCounter(1, qs_product.closest('.js-quick-shop-product'));
              }
            }

            // Add new product
            if (add_new_product) {
              let bundle_product_data = {
                product: product,
                variant: variant,
                quantity: 1
              };
              bundle.state.products.push(bundle_product_data);
              bundle.state.current_total++;
              updateProductCounter(1, qs_product.closest('.js-quick-shop-product'));
            }

            if (bundle.state.current_total === 5 && bundle.state.bundle_size === 5) {
              console.log('Wanna upgrade?');
              bundle.nodes.message.classList.add('hidden');
              bundle.nodes.message_upgrade_5.classList.remove('hidden');
              bundle.nodes.message_upgrade_5.addEventListener('animationend', (e) => {
                bundle.nodes.message_upgrade_5.classList.remove('show');
                bundle.nodes.message_upgrade_5.classList.add('hidden');
              });
              bundle.nodes.message_upgrade_5.classList.add('show');
            }

            if (bundle.state.current_total === bundle.state.bundle_size - 1) {
              console.log('One more to go!');
              bundle.nodes.message.classList.remove('hidden');
              bundle.nodes.message.textContent = 'One more to go!';
              bundle.nodes.message_box.addEventListener('animationend', (e) => {
                bundle.nodes.message_box.classList.remove('show');
                bundle.nodes.message.classList.add('hidden');
              });
              bundle.nodes.message_box.classList.add('show');
            }

            let has_12_pack = document.querySelector('.js-bundle-select-product[data-size="12"]');

            if (bundle.state.current_total === 7 && bundle.state.bundle_size === 7 && has_12_pack) {
              console.log('Wanna upgrade?');
              bundle.nodes.message.classList.add('hidden');
              bundle.nodes.message_upgrade_7.classList.remove('hidden');
              bundle.nodes.message_upgrade_7.addEventListener('animationend', (e) => {
                bundle.nodes.message_upgrade_7.classList.remove('show');
                bundle.nodes.message_upgrade_7.classList.add('hidden');
              });
              bundle.nodes.message_upgrade_7.classList.add('show');
            }

            // Check if bundle is full
            if (bundle.state.current_total === bundle.state.bundle_size) {
              bundle.nodes.message_box.classList.remove('show');
              bundle.nodes.message.classList.add('hidden');
              bundle.state.step++;
              console.log('add to cart state', bundle.state);
              // Prepare add to cart
              bundle.nodes.button_progress.classList.add('hidden');
              bundle.nodes.button_review_bundle.classList.remove('hidden');

              buildBundleReviewProducts(bundle.state.products);
              disableAddToBundle();
            } else {
              // Update state
              bundle.state.step++;
              console.log('state', bundle.state);
              // bundle.nodes.button_progress_message.textContent = step_messages[bundle.state.step];
              bundle.nodes.button_progress_count.textContent = `${bundle.state.step} / ${bundle.state.steps_total}`;
              bundle.nodes.button_progress_indicator.style.width =
                (bundle.state.step / bundle.state.steps_total) * 100 + '%';
            }
          } else {
            alert('Sorry, this product is out of stock. Please pick something else to add to your bundle.');
          }
        });
      });
    }
  }
})();
